//import registerCheckoutBlock from '@woocommerce/blocks-checkout';
import { registerBlockType } from '@wordpress/blocks';
import { SVG } from '@wordpress/components';
import { Edit, Save } from './edit';
import metadata from './block.json';


registerBlockType(metadata, {
	icon: {
		src: (
			<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" >
				<defs>
				</defs>
				<g id="surface1">
					<path
						style={{
							stroke: "none",
							fillRule: "nonzero",
							fill: "rgb(39.607843%,39.607843%,39.607843%)",
							fillOpacity: 1,
						}}
						d="M 195.1875 173.464844 L 96.375 173.464844 L 84.289062 112.695312 L 229.003906 112.695312 Z M 195.1875 173.464844 "
					/>
					<path
						style={{
							stroke: "none",
							fillRule: "nonzero",
							fill: "rgb(39.607843%,39.607843%,39.607843%)",
							fillOpacity: 1,
						}}
						d="M 30.625 101.136719 C 27.105469 99.339844 26.03125 95.613281 28.023438 92.652344 C 30.164062 89.695312 34.746094 88.671875 38.269531 90.464844 C 55.246094 98.945312 66.871094 113.976562 74.828125 133.636719 C 81.867188 150.976562 85.988281 171.917969 88.589844 194.917969 L 207.277344 194.917969 C 211.261719 194.917969 214.625 197.738281 214.625 201.210938 C 214.625 204.679688 211.265625 207.375 207.277344 207.375 L 82.476562 207.375 C 78.34375 207.628906 74.828125 205.191406 74.519531 201.722656 C 72.074219 177.3125 67.945312 155.34375 60.757812 137.617188 C 53.875 120.789062 44.390625 107.941406 30.625 101.136719 Z M 30.625 101.136719 "
					/>
					<path
						style={{
							stroke: "none",
							fillRule: "nonzero",
							fill: "rgb(39.607843%,39.607843%,39.607843%)",
							fillOpacity: 1,
						}}
						d="M 109.210938 235 C 109.210938 244.71875 99.832031 252.597656 88.257812 252.597656 C 76.6875 252.597656 67.304688 244.71875 67.304688 235 C 67.304688 225.28125 76.6875 217.402344 88.257812 217.402344 C 99.832031 217.402344 109.210938 225.28125 109.210938 235 Z M 109.210938 235 "
					/>
					<path
						style={{
							stroke: "none",
							fillRule: "nonzero",
							fill: "rgb(39.607843%,39.607843%,39.607843%)",
							fillOpacity: 1,
						}}
						d="M 212.929688 235 C 212.929688 244.71875 203.550781 252.597656 191.976562 252.597656 C 180.40625 252.597656 171.023438 244.71875 171.023438 235 C 171.023438 225.28125 180.40625 217.402344 191.976562 217.402344 C 203.550781 217.402344 212.929688 225.28125 212.929688 235 Z M 212.929688 235 "
					/>
					<path
						style={{
							stroke: "none",
							fillRule: "nonzero",
							fill: "rgb(39.607843%,39.607843%,39.607843%)",
							fillOpacity: 1,
						}}
						d="M 60.980469 5.097656 L 81.292969 5.097656 C 82.5 5.097656 83.476562 5.964844 83.476562 7.03125 L 83.476562 29.246094 L 108.546875 29.246094 C 109.75 29.246094 110.722656 30.113281 110.722656 31.179688 L 110.722656 49.125 C 110.722656 50.195312 109.75 51.054688 108.546875 51.054688 L 83.476562 51.054688 L 83.476562 73.273438 C 83.476562 74.34375 82.5 75.207031 81.292969 75.207031 L 60.980469 75.207031 C 59.78125 75.207031 58.804688 74.339844 58.804688 73.273438 L 58.804688 51.058594 L 33.730469 51.058594 C 32.527344 51.058594 31.550781 50.195312 31.550781 49.125 L 31.550781 31.179688 C 31.550781 30.109375 32.527344 29.246094 33.730469 29.246094 L 58.804688 29.246094 L 58.804688 7.03125 C 58.804688 5.964844 59.78125 5.097656 60.980469 5.097656 Z M 60.980469 5.097656 "
					/>
					<path
						style={{
							stroke: "none",
							fillRule: "nonzero",
							fill: "rgb(39.607843%,39.607843%,39.607843%)",
							fillOpacity: 1,
						}}
						d="M 232.992188 37.589844 C 232.992188 44.703125 227.691406 50.472656 221.148438 50.472656 L 154.214844 50.472656 C 147.675781 50.472656 142.375 44.703125 142.375 37.589844 C 142.375 30.476562 147.675781 24.707031 154.214844 24.707031 L 221.148438 24.707031 C 227.691406 24.707031 232.992188 30.476562 232.992188 37.589844 Z M 232.992188 37.589844 "
					/>
				</g>

			</SVG>
		),
		foreground: '#874FB9',
	},
	edit: Edit,
	save: Save,
	

});